import React from 'react';
import { Reveal } from '../common/Reveal';

export function Stats() {
  const stats = [
    ['70+', 'Projects Completed'],
    ['8+', 'Years of Excellence'],
    ['100%', 'Client Satisfaction'],
  ];

  return (
    <div id="intro" className="bg-nestlent-charcoal py-16 px-8 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-[1fr_2px_1fr_2px_1fr] gap-8 md:gap-12 items-center">
        {stats.map(([num, label], i) => (
          <React.Fragment key={i}>
            <Reveal className="text-center" delay={i * 150} y={20}>
              <div className="font-serif text-[3rem] font-light text-nestlent-green-mid leading-none mb-1">
                {num}
              </div>
              <div className="text-[0.72rem] tracking-[0.2em] uppercase text-white/50">
                {label}
              </div>
            </Reveal>
            {i < 2 && (
              <div className="hidden md:block bg-white/[0.12] h-[60px]" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
